/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramChatsUserControllerCreateMessageMutationRequest,
  TelegramChatsUserControllerCreateMessageMutationResponse,
  TelegramChatsUserControllerCreateMessagePathParams,
  TelegramChatsUserControllerCreateMessage401,
  TelegramChatsUserControllerCreateMessage403,
  TelegramChatsUserControllerCreateMessage404,
} from '../../types/TelegramChatsUserControllerCreateMessage.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramChatsUserCreateMessage } from '../../methods/telegramChatsUserCreateMessage.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramChatsUserCreateMessageMutationKey = () =>
  [{ url: '/api/user/telegram/chats/:id/message' }] as const;

export type TelegramChatsUserCreateMessageMutationKey = ReturnType<typeof telegramChatsUserCreateMessageMutationKey>;

/**
 * {@link /api/user/telegram/chats/:id/message}
 */
export function useTelegramChatsUserCreateMessage<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramChatsUserControllerCreateMessageMutationResponse,
      ResponseErrorConfig<
        | TelegramChatsUserControllerCreateMessage401
        | TelegramChatsUserControllerCreateMessage403
        | TelegramChatsUserControllerCreateMessage404
      >,
      {
        id: TelegramChatsUserControllerCreateMessagePathParams['id'];
        data?: TelegramChatsUserControllerCreateMessageMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramChatsUserControllerCreateMessageMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramChatsUserCreateMessageMutationKey();

  return useMutation<
    TelegramChatsUserControllerCreateMessageMutationResponse,
    ResponseErrorConfig<
      | TelegramChatsUserControllerCreateMessage401
      | TelegramChatsUserControllerCreateMessage403
      | TelegramChatsUserControllerCreateMessage404
    >,
    {
      id: TelegramChatsUserControllerCreateMessagePathParams['id'];
      data?: TelegramChatsUserControllerCreateMessageMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return telegramChatsUserCreateMessage(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
